<div class="mdl-layout mdl-js-layout">
  <main class="mdl-layout__content">
    <router-outlet></router-outlet>
  </main>
</div>
